<template>
    <div class="performance">
        <p>performance</p>
    </div>
</template>

<script>
export default {
    data(){
        return{
            
        }
    }
}
</script>

<style lang="scss" scoped>
.performance{
    
}
</style>